'use client';

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@ui/components/ui/dialog';

import { ProfileShareContent, ProfileShareContentProps } from './ProfileShareContent';

export interface ProfileShareDialogProps extends Omit<ProfileShareContentProps, 'showHeader'> {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
}

export function ProfileShareDialog({
  isOpen,
  onClose,
  profileUrl,
  userName,
  logoUrl,
  roleText,
  companyName,
  translations,
  onSaveAndDownload,
  title = 'Share Profile'
}: ProfileShareDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center">
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription className="sr-only">Profile sharing options</DialogDescription>
        </DialogHeader>

        <ProfileShareContent
          profileUrl={profileUrl}
          userName={userName}
          logoUrl={logoUrl}
          roleText={roleText}
          companyName={companyName}
          isMobile={false}
          translations={translations}
          onSaveAndDownload={onSaveAndDownload}
          showHeader={false}
        />
      </DialogContent>
    </Dialog>
  );
}
